import { get } from 'lodash'
import { STORAGE_TRANSACTION_KEY } from '@/common/resources/const'

export const isSupportLocalStorage = () => {
  return storageAvailable('localStorage')
}
export const isSupperSessionStorage = () => {
  return storageAvailable('sessionStorage')
}

function storageAvailable(type) {
  var storage
  try {
    storage = window[type]
    var x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      // Firefox를 제외한 모든 브라우저
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // 코드가 존재하지 않을 수도 있기 떄문에 이름 필드도 확인합니다.
        // Firefox를 제외한 모든 브라우저
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // 이미 저장된 것이있는 경우에만 QuotaExceededError를 확인하십시오.
      storage &&
      storage.length !== 0
    )
  }
}

const localStorageUtil = {
  set: (key, value) => {
    localStorage.setItem(key, value)
  },
  get: (key) => {
    return localStorage.getItem(key)
  },
  remove: (key) => {
    localStorage.removeItem(key)
  },
  clear: () => {
    localStorage.clear()
  },
  /**
   * 지정된 예외목록에 명시된 키를 제외하고 localStorage를 비웁니다.
   *
   * @param {string[] | string} [exception=[]] - 제거하지 않을 키(들의 배열)
   */
  clearExceptKeys: (exception = []) => {
    // exception이 문자열인 경우 배열로 변환
    const exceptionList =
      typeof exception === 'string' ? [exception] : exception

    if (!Array.isArray(exceptionList)) {
      localStorage.clear()
      return
    }
    console.log('exceptionList', exceptionList)
    Object.keys(localStorage).forEach((key) => {
      if (!exceptionList.includes(key)) {
        localStorage.removeItem(key)
      }
    })
  },
}

const sessionStorageUtil = {
  set: (key, value) => {
    sessionStorage.setItem(key, value)
  },
  get: (key) => {
    return sessionStorage.getItem(key)
  },
  remove: (key) => {
    sessionStorage.removeItem(key)
  },
  clear: () => {
    sessionStorage.clear()
  },
  /**
   * 지정된 예외목록에 명시된 키를 제외하고 sessionStorage를 비웁니다.
   *
   * @param {string[]} [exception=[]] - 제거하지 않을 키(들의 배열)
   */
  clearExceptKeys: (exception = []) => {
    // exception이 문자열인 경우 배열로 변환
    const exceptionList =
      typeof exception === 'string' ? [exception] : exception

    if (!Array.isArray(exceptionList)) {
      sessionStorage.clear()
      return
    }
    Object.keys(sessionStorage).forEach((key) => {
      if (!exceptionList.includes(key)) {
        sessionStorage.removeItem(key)
      }
    })
  },
}

let memoryStorage = {}
const memoryStorageUtil = {
  set: (key, value) => {
    memoryStorage[key] = value
  },
  get: (key) => {
    return memoryStorage[key]
  },
  remove: (key) => {
    delete memoryStorage[key]
  },
  clear: () => {
    memoryStorage = {}
  },
  /**
   * 지정된 예외목록에 명시된 키를 제외하고 memoryStorage를 비웁니다.
   *
   * @param {string[]} [exception=[]] - 제거하지 않을 키(들의 배열)
   */
  clearExceptKeys: (exception = []) => {
    // exception이 문자열인 경우 배열로 변환
    const exceptionList =
      typeof exception === 'string' ? [exception] : exception

    if (!Array.isArray(exceptionList)) {
      memoryStorage = {}
      return
    }
    memoryStorage = Object.keys(memoryStorage).reduce((acc, key) => {
      if (exceptionList.includes(key)) {
        acc[key] = memoryStorage[key]
      }
      return acc
    }, {})
  },
}

export const getStorage = () => {
  if (isSupportLocalStorage()) {
    return localStorageUtil
  } else {
    return memoryStorageUtil
  }
}

export const getSessionStorage = () => {
  if (isSupperSessionStorage()) {
    return sessionStorageUtil
  } else {
    return memoryStorageUtil
  }
}

/**
 * data 를 받아 transaction key 가 있으면 session storage 에 transaction key 를 업데이트 한다.
 * @param data
 */
export const setTransactionKeyToStorage = (data) => {
  if (get(data, 'transactionkey', '')) {
    sessionStorage.setItem(
      STORAGE_TRANSACTION_KEY,
      get(data, 'transactionkey', ''),
    )
  }
}
